export class NoOpDataSourceValueInfoSource {
  getIcon(value) {
    return null;
  }
  getClassDisplayName(value) {
    return null;
  }
  getFeatureIndicator(value, feature) {
    return null;
  }
  refresh() {
    // nothing to do here.
  }
}
//# sourceMappingURL=NoOpDataSourceValueInfoSource.js.map
